__turbopack_context__.v({
  "designPreviewContainer": "T1snxW_designPreviewContainer",
  "displayIcon": "T1snxW_displayIcon",
  "partImage": "T1snxW_partImage",
});
